import { Button, Stack, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useDownloadOrbitLContractMutation } from "Api/Mutations/Merchants/useDownloadOrbitLContractMutation";
import { OrbitLContractType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Merchant.OrbitL.Contract;

type Props = {
  merchantPublicID: string;
  isLoanContractRequired: boolean;
};

export const OrbitLContractDownloads = ({
  merchantPublicID,
  isLoanContractRequired,
}: Props) => {
  const { t } = useResource();
  const paymentServicesMutation = useDownloadOrbitLContractMutation();
  const loanMutation = useDownloadOrbitLContractMutation();

  return (
    <Stack gap={1}>
      <Typography variant="subtitle2" color="text.secondary">
        {t(RESOURCES.DocumentsHeading)}
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap">
        <Button
          variant="outlined"
          size="small"
          startIcon={<DownloadIcon />}
          onClick={() =>
            paymentServicesMutation.mutate({
              merchantPublicID,
              contractType: OrbitLContractType.PaymentServices,
              fileNamePrefix: t(RESOURCES.PaymentServicesFileName),
            })
          }
          disabled={paymentServicesMutation.isPending}
        >
          {t(RESOURCES.PaymentServicesTitle)}
        </Button>
        {isLoanContractRequired && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<DownloadIcon />}
            onClick={() =>
              loanMutation.mutate({
                merchantPublicID,
                contractType: OrbitLContractType.Loan,
                fileNamePrefix: t(RESOURCES.LoanFileName),
              })
            }
            disabled={loanMutation.isPending}
          >
            {t(RESOURCES.LoanTitle)}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
